import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { TrackerService } from '../../core/tracker/tracker.service';
import { BaseComponent } from '../../shared/base.component';
import { SessionStorageService } from "ngx-webstorage";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AccountService } from '../../core/auth/account.service';
import { SRQCompletedService } from '../srq-completed/srq-completed.service';
import { FlowManagerService } from '../../core/util/flow-manager.service';
import { WellbeingScanService } from '../wellbeing-scan/wellbeing-scan.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/tracker/tracker.service";
import * as i2 from "@angular/router";
import * as i3 from "../../core/auth/account.service";
import * as i4 from "../srq-completed/srq-completed.service";
import * as i5 from "../../core/util/flow-manager.service";
import * as i6 from "ngx-webstorage";
import * as i7 from "@ng-bootstrap/ng-bootstrap";
import * as i8 from "../wellbeing-scan/wellbeing-scan.service";
import * as i9 from "../../shared/wellbeing-header/wellbeing-header.component";
import * as i10 from "@angular/common";
import * as i11 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i12 from "@fortawesome/angular-fontawesome";
function WellbeingScanComponent_div_2_ng_template_2_Template(rf, ctx) { }
function WellbeingScanComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵtemplate(2, WellbeingScanComponent_div_2_ng_template_2_Template, 0, 0, "ng-template", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r11 = i0.ɵɵreference(33);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r11);
} }
const _c0 = function (a0) { return { width: a0 }; };
function WellbeingScanComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "div", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c0, ctx_r1.calculateProgressBarWidth()));
} }
function WellbeingScanComponent_h4_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h4", 27);
} }
function WellbeingScanComponent_fa_icon_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 28);
} }
function WellbeingScanComponent_fa_icon_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 28);
} }
function WellbeingScanComponent_div_18_ng_template_2_Template(rf, ctx) { }
function WellbeingScanComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵtemplate(2, WellbeingScanComponent_div_18_ng_template_2_Template, 0, 0, "ng-template", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r11 = i0.ɵɵreference(33);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r11);
} }
function WellbeingScanComponent_fa_icon_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 28);
} }
function WellbeingScanComponent_fa_icon_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 28);
} }
function WellbeingScanComponent_a_29_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵlistener("click", function WellbeingScanComponent_a_29_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.displayPreviousQuestion(); });
    i0.ɵɵelement(1, "img", 32);
    i0.ɵɵelement(2, "h4", 33);
    i0.ɵɵelementEnd();
} }
function WellbeingScanComponent_a_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a");
} }
function WellbeingScanComponent_a_31_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 34);
    i0.ɵɵlistener("click", function WellbeingScanComponent_a_31_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.displayNextQuestion(); });
    i0.ɵɵelement(1, "h4", 35);
    i0.ɵɵelement(2, "img", 36);
    i0.ɵɵelementEnd();
} }
function WellbeingScanComponent_ng_template_32_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelement(1, "p", 42);
    i0.ɵɵelementEnd();
} }
function WellbeingScanComponent_ng_template_32_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵlistener("click", function WellbeingScanComponent_ng_template_32_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.showWhyAsk = !ctx_r20.showWhyAsk; });
    i0.ɵɵelement(1, "h4", 38);
    i0.ɵɵelement(2, "img", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, WellbeingScanComponent_ng_template_32_div_3_Template, 2, 0, "div", 40);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r12.showWhyAsk);
} }
export class WellbeingScanComponent extends BaseComponent {
    constructor(elementRef, trackerService, router, accountService, srqService, flowManagerService, activatedRoute, sessionStorage, modalService, wellbeingScanService) {
        super(sessionStorage, modalService);
        this.elementRef = elementRef;
        this.trackerService = trackerService;
        this.router = router;
        this.accountService = accountService;
        this.srqService = srqService;
        this.flowManagerService = flowManagerService;
        this.activatedRoute = activatedRoute;
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.wellbeingScanService = wellbeingScanService;
        this.imagePath = '../../../../../content/images/wellbeing';
        this.imageClass = 'test-image';
        this.currentQuestion = 0;
        this.answers = [];
        this.account = null;
        this.noStyle = 'btn-secondary';
        this.yesStyle = 'btn-secondary';
        this.firstButtonText = 'inukaNgApp.wellbeingScan.no';
        this.secondButtonText = 'inukaNgApp.wellbeingScan.yes';
        this.isFirstScan = true;
        this.showWhyAsk = false;
        this.endingYourLifeQuestionIndex = 16;
        this.endingYourLifeQuestionHideScore = 10;
    }
    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#FFFFFF';
        this.activatedRoute.params.subscribe((params) => {
            let question = params["question"];
            this.currentQuestion = Number(question) - 1;
            console.log("flow currentQuestion: " + this.currentQuestion);
            if (this.wellbeingScanService.hasAnySavedSrqAnswers())
                this.answers = this.wellbeingScanService.getSavedSrqAnswers();
            this.renderCurrentPage();
        });
        if (this.accountService.isAuthenticated()) {
            // this.srqService.srqHistory().subscribe((res: HttpResponse<ISRQCompleted[]>) => {
            //   if (res.body && res.body.length) {
            //     this.isFirstScan = false;
            //   }
            // });
        }
        if (this.flowManagerService.getPreviousUrl().startsWith('/wellbeing-start')) {
            this.trackerService.sendActivity("self_scan_started");
        }
    }
    selectAnswer(answerText) {
        this.trackerService.sendActivity("ss_question_answered_" + this.currentQuestion, { 'question_answer': answerText });
        if (answerText === 'Yes') {
            this.yesStyle = 'btn-primary';
            this.noStyle = 'btn-secondary';
        }
        else if (answerText === 'No') {
            this.noStyle = 'btn-primary';
            this.yesStyle = 'btn-secondary';
        }
        setTimeout(() => {
            if (!this.answers[this.currentQuestion + 1] && this.currentQuestion < 19) {
                this.yesStyle = 'btn-secondary';
                this.noStyle = 'btn-secondary';
            }
            this.answers[this.currentQuestion] = answerText;
            this.displayNextQuestion();
        }, 100);
    }
    displayNextQuestion() {
        if (this.currentQuestion < 19) {
            let nextQuestion = this.currentQuestion + 1;
            if (nextQuestion === this.endingYourLifeQuestionIndex) {
                const score = this.calculateScore();
                if (score >= this.endingYourLifeQuestionHideScore) {
                    // prevent showing the question 17 and jump to the next question
                    this.answers[this.endingYourLifeQuestionIndex] = "NotAnswered";
                    nextQuestion++;
                }
            }
            this.currentQuestion = nextQuestion;
            this.router.navigate(["/wellbeing-scan", this.currentQuestion + 1]);
        }
        else {
            this.wellbeingScanService.saveSrqAnswers(this.answers);
            // if (this.isFirstScan) {
            // we now show the looking for help topics question in any case, no matter how many times they did answer it
            this.router.navigate(['/looking-for-help-topics']);
            // } else {
            //   // this.router.navigate(['/wellbeing-finish']);
            //   this.router.navigate(['/wellbeing-extra-questions/1']);
            // }
        }
    }
    calculateScore() {
        let score = 0;
        if (this.answers) {
            for (const answer of this.answers) {
                if (answer === "No") {
                    score++;
                }
            }
        }
        return score;
    }
    displayPreviousQuestion() {
        this.trackerService.sendActivity("ss_question_previous_btn_clicked_" + this.currentQuestion);
        if (this.currentQuestion > 0) {
            this.currentQuestion--;
            if (this.currentQuestion === this.endingYourLifeQuestionIndex &&
                this.answers[this.endingYourLifeQuestionIndex] === 'NotAnswered') {
                this.displayPreviousQuestion();
                return;
            }
            this.router.navigate(["/wellbeing-scan", this.currentQuestion + 1]);
        }
        else {
            this.router.navigate(['/wellbeing-start']);
        }
    }
    renderCurrentPage() {
        this.yesStyle = 'btn-secondary';
        this.noStyle = 'btn-secondary';
        if (this.currentQuestion === 20) {
            this.firstButtonText = 'inukaNgApp.wellbeingScan.back';
            this.secondButtonText = 'inukaNgApp.wellbeingScan.toResults';
            this.noStyle = 'btn-secondary';
            this.yesStyle = 'btn-primary';
            this.imageClass = 'well-done-image';
        }
        else {
            this.firstButtonText = 'inukaNgApp.wellbeingScan.no';
            this.secondButtonText = 'inukaNgApp.wellbeingScan.yes';
            this.imageClass = 'test-image';
            if (this.answers[this.currentQuestion] === 'Yes') {
                this.yesStyle = 'btn-primary';
                this.noStyle = 'btn-secondary';
            }
            else if (this.answers[this.currentQuestion] === 'No') {
                this.yesStyle = 'btn-secondary';
                this.noStyle = 'btn-primary';
            }
        }
    }
    showPrevious() {
        return (this.currentQuestion !== 20);
    }
    showNext() {
        return this.answers[this.currentQuestion] !== undefined;
    }
    questionText() {
        return 'inukaNgApp.wellbeingScan.q' + this.currentQuestion;
    }
    questionImage() {
        return this.imagePath + '/' + this.currentQuestion + '.png';
    }
    answeredNo() {
        return 'No' === this.answers[this.currentQuestion];
    }
    answeredYes() {
        return 'Yes' === this.answers[this.currentQuestion];
    }
    calculateProgressBarWidth() {
        let percentage = 5 * (this.currentQuestion + 1);
        return percentage + '%';
    }
}
WellbeingScanComponent.ɵfac = function WellbeingScanComponent_Factory(t) { return new (t || WellbeingScanComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.TrackerService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i3.AccountService), i0.ɵɵdirectiveInject(i4.SRQCompletedService), i0.ɵɵdirectiveInject(i5.FlowManagerService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i6.SessionStorageService), i0.ɵɵdirectiveInject(i7.NgbModal), i0.ɵɵdirectiveInject(i8.WellbeingScanService)); };
WellbeingScanComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WellbeingScanComponent, selectors: [["wellbeing-scan"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 34, vars: 27, consts: [[1, "olha-theme", 2, "margin-bottom", "40px!important", "position", "relative"], ["class", "d-lg-none mt-2", "style", "position: absolute; top: -130px; left: 0; right: 0; z-index: 1000;", 4, "ngIf"], [1, "container", "bg-2"], ["class", "progress", "style", "border-radius: 5px; width: 60%; height: 10px; margin: auto;", 4, "ngIf"], [1, "last-seven-div"], ["jhiTranslate", "inukaNgApp.wellbeingScan.last7days", 4, "ngIf"], ["id", "ss-question-text", 1, "question-text", 3, "jhiTranslate"], ["alt", "question image", 3, "src"], [1, "d-none", "d-md-block", "d-lg-block", "d-xl-block", "mt-55"], [1, "d-flex", "justify-content-center", "position-relative"], ["id", "ss-answer-no-btn", 1, "btn", 3, "click"], [3, "jhiTranslate"], ["icon", "check", 4, "ngIf"], ["id", "ss-answer-yes-btn", 1, "btn", 3, "click"], ["class", "d-none d-lg-block d-xl-block absolute-container", 4, "ngIf"], [1, "d-md-none", "mt-55"], [1, "btn", 3, "click"], [1, "d-flex", "justify-content-center"], ["class", "d-flex justify-content-center arrow-anchor", "id", "ss-previous-btn", 3, "click", 4, "ngIf"], [4, "ngIf"], ["class", "d-flex justify-content-center arrow-anchor", "id", "ss-next-btn", 3, "click", 4, "ngIf"], ["why17", ""], [1, "d-lg-none", "mt-2", 2, "position", "absolute", "top", "-130px", "left", "0", "right", "0", "z-index", "1000"], [1, "container", "bg-1", 2, "padding-top", "20px!important", "padding-bottom", "20px!important", "border-top-left-radius", "0!important", "border-top-right-radius", "0!important", "margin-left", "0!important", "margin-right", "0!important"], [3, "ngTemplateOutlet"], [1, "progress", 2, "border-radius", "5px", "width", "60%", "height", "10px", "margin", "auto"], ["role", "progressbar", 1, "progress-bar", 2, "width", "5%", 3, "ngStyle"], ["jhiTranslate", "inukaNgApp.wellbeingScan.last7days"], ["icon", "check"], [1, "d-none", "d-lg-block", "d-xl-block", "absolute-container"], [1, "bg-1", "why-17-div"], ["id", "ss-previous-btn", 1, "d-flex", "justify-content-center", "arrow-anchor", 3, "click"], ["src", "../../../../content/images/wellbeing/previous-icon.png", "alt", "previous", 1, "previous-icon"], ["jhiTranslate", "inukaNgApp.wellbeingScan.previous", 1, "previous-header"], ["id", "ss-next-btn", 1, "d-flex", "justify-content-center", "arrow-anchor", 3, "click"], ["jhiTranslate", "inukaNgApp.wellbeingScan.next", 1, "next-header"], ["src", "../../../../content/images/wellbeing/next-icon.png", "alt", "next", 1, "next-icon"], [1, "wellbeing-start-text", "d-flex", "justify-content-between", 2, "cursor", "pointer", 3, "click"], ["jhiTranslate", "inukaNgApp.wellbeingScan.whyAsk17", 2, "text-align", "left"], ["src", "../../../../content/images/wellbeing/vector-down.png", "alt", "vector-down", 1, "arrow-down-icon"], ["class", "wellbeing-start-text", 4, "ngIf"], [1, "wellbeing-start-text"], ["jhiTranslate", "inukaNgApp.wellbeingScan.srq20", 1, "srq-20-text"]], template: function WellbeingScanComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "wellbeing-header");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵtemplate(2, WellbeingScanComponent_div_2_Template, 3, 1, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div");
        i0.ɵɵtemplate(5, WellbeingScanComponent_div_5_Template, 2, 3, "div", 3);
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵtemplate(7, WellbeingScanComponent_h4_7_Template, 1, 0, "h4", 5);
        i0.ɵɵelement(8, "h2", 6);
        i0.ɵɵelement(9, "img", 7);
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵelementStart(12, "button", 10);
        i0.ɵɵlistener("click", function WellbeingScanComponent_Template_button_click_12_listener() { return ctx.selectAnswer("No"); });
        i0.ɵɵelement(13, "span", 11);
        i0.ɵɵtemplate(14, WellbeingScanComponent_fa_icon_14_Template, 1, 0, "fa-icon", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "button", 13);
        i0.ɵɵlistener("click", function WellbeingScanComponent_Template_button_click_15_listener() { return ctx.selectAnswer("Yes"); });
        i0.ɵɵelement(16, "span", 11);
        i0.ɵɵtemplate(17, WellbeingScanComponent_fa_icon_17_Template, 1, 0, "fa-icon", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, WellbeingScanComponent_div_18_Template, 3, 1, "div", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 15);
        i0.ɵɵelementStart(20, "div");
        i0.ɵɵelementStart(21, "button", 16);
        i0.ɵɵlistener("click", function WellbeingScanComponent_Template_button_click_21_listener() { return ctx.selectAnswer("Yes"); });
        i0.ɵɵelement(22, "span", 11);
        i0.ɵɵtemplate(23, WellbeingScanComponent_fa_icon_23_Template, 1, 0, "fa-icon", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div");
        i0.ɵɵelementStart(25, "button", 16);
        i0.ɵɵlistener("click", function WellbeingScanComponent_Template_button_click_25_listener() { return ctx.selectAnswer("No"); });
        i0.ɵɵelement(26, "span", 11);
        i0.ɵɵtemplate(27, WellbeingScanComponent_fa_icon_27_Template, 1, 0, "fa-icon", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 17);
        i0.ɵɵtemplate(29, WellbeingScanComponent_a_29_Template, 3, 0, "a", 18);
        i0.ɵɵtemplate(30, WellbeingScanComponent_a_30_Template, 1, 0, "a", 19);
        i0.ɵɵtemplate(31, WellbeingScanComponent_a_31_Template, 3, 0, "a", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(32, WellbeingScanComponent_ng_template_32_Template, 4, 1, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.currentQuestion === ctx.endingYourLifeQuestionIndex);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.currentQuestion < 20);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.currentQuestion < 20);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("jhiTranslate", ctx.questionText());
        i0.ɵɵadvance(1);
        i0.ɵɵclassMap(ctx.imageClass);
        i0.ɵɵpropertyInterpolate("src", ctx.questionImage(), i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap(ctx.noStyle);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("jhiTranslate", ctx.firstButtonText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.answeredNo());
        i0.ɵɵadvance(1);
        i0.ɵɵclassMap(ctx.yesStyle);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("jhiTranslate", ctx.secondButtonText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.answeredYes());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.currentQuestion === ctx.endingYourLifeQuestionIndex);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap(ctx.yesStyle);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("jhiTranslate", ctx.secondButtonText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.answeredYes());
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(ctx.noStyle);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("jhiTranslate", ctx.firstButtonText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.answeredNo());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showPrevious());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showNext());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showNext());
    } }, directives: [i9.WellbeingHeaderComponent, i10.NgIf, i11.JhiTranslateDirective, i10.NgTemplateOutlet, i10.NgStyle, i12.FaIconComponent], styles: [".olha-theme[_ngcontent-%COMP%]{position:relative}.container[_ngcontent-%COMP%]{margin:90px 20px 10px !important;height:auto;width:auto;max-width:1169px !important;padding-top:30px;text-align:center}.absolute-container[_ngcontent-%COMP%]{position:absolute;bottom:-50px;right:-30px}.why-17-div[_ngcontent-%COMP%]{padding:20px;width:300px}.arrow-down-icon[_ngcontent-%COMP%]{height:7px;width:14px;margin-top:10px}.srq-20-text[_ngcontent-%COMP%]{margin:14px !important;font-size:12px !important;text-align:left !important}.progress[_ngcontent-%COMP%]{background-color:#e1e1e1}.progress-bar[_ngcontent-%COMP%]{background-color:var(--main)}.last-seven-div[_ngcontent-%COMP%]{margin-top:50px}.help-div[_ngcontent-%COMP%]{margin-top:40px}.question-text[_ngcontent-%COMP%]{color:var(--text);font-size:20px}.test-image[_ngcontent-%COMP%]{height:140px;width:140px;margin-top:40px}.well-done-image[_ngcontent-%COMP%]{height:255px;width:336px;margin-top:40px}button[_ngcontent-%COMP%], a[_ngcontent-%COMP%]{height:50px;width:170px;margin:10px;position:relative}fa-icon[_ngcontent-%COMP%]{font-size:14px;font-weight:bold !important;position:absolute;top:12px;right:17px}span[_ngcontent-%COMP%]{font-size:14px;font-weight:bold !important}.previous-icon[_ngcontent-%COMP%], .previous-header[_ngcontent-%COMP%], .next-header[_ngcontent-%COMP%], .next-icon[_ngcontent-%COMP%]{position:absolute;top:50%;transform:translateY(-50%)}.previous-icon[_ngcontent-%COMP%]{left:0}.previous-header[_ngcontent-%COMP%]{left:25px}.next-icon[_ngcontent-%COMP%]{right:0}.next-header[_ngcontent-%COMP%]{right:25px}.arrow-anchor[_ngcontent-%COMP%]{position:relative}.mt-55[_ngcontent-%COMP%]{margin-top:40px}@media(min-width: 768px){.question-text[_ngcontent-%COMP%]{font-size:26px}.test-image[_ngcontent-%COMP%]{height:170px;width:170px}.mt-55[_ngcontent-%COMP%]{margin-top:55px}}@media(min-width: 1200px){.container[_ngcontent-%COMP%]{margin:90px auto 30px !important;padding-top:60px;height:720px}}@media(min-width: 1150px){.why-17-div[_ngcontent-%COMP%]{width:350px}}@media(min-width: 1250px){.absolute-container[_ngcontent-%COMP%]{right:-50px}.why-17-div[_ngcontent-%COMP%]{width:400px}}@media(min-width: 1350px){.absolute-container[_ngcontent-%COMP%]{right:-100px}}"] });
